// Single source of truth for the "primary" listing query shape.
//
// Both the category listing page (app/pages/[...slug].vue) and the cache
// warmer (server/utils/warmup/top-categories.ts) must send byte-identical
// requests to /api/store/categories/{products,filters}/[id] so they hit the
// SAME Nitro SWR cache key. The key is hash(raw req.url), so query KEY ORDER
// and VALUES are load-bearing — keep them defined here, in one place.
//
// Key order matters: ofetch serialises via ufo `withQuery`, which preserves
// object insertion order. The page spreads `...route.query` first, then these
// keys, so for an unfiltered landing the order is exactly:
//   currentUrl, filters_scope, primary_filters_limit

export const PRIMARY_FILTERS_LIMIT = 10

export interface PrimaryListingQuery {
  currentUrl: string
  filters_scope: 'primary'
  primary_filters_limit: number
}

/**
 * Build the query object for the primary (top-N) filters view of a listing.
 * `currentUrl` is the canonical browser route (route.fullPath) — it is part of
 * the cache key, so it must match what the browser actually navigates to.
 */
export function buildPrimaryListingQuery(currentUrl: string): PrimaryListingQuery {
  return {
    currentUrl,
    filters_scope: 'primary',
    primary_filters_limit: PRIMARY_FILTERS_LIMIT,
  }
}
